import { reqGet, reqPost, reqPatch, reqDelete } from './index';

export const getDashboardListApi = param =>
    reqGet('/v3/api/common/user/widget/menu', { ...param, isAll: 'Y', pageSize: 0 });
export const getDashboardApi = param => reqGet(`/v3/api/common/user/widget/menu/${param.menuNum}`, param);
export const createDashboardApi = param => reqPost('/v3/api/common/user/widget/menu', param);
export const updateDashboardApi = param => reqPatch(`/v3/api/common/user/widget/menu/${param.menuNum}`, param);
export const deleteDashboardApi = param => reqDelete(`/v3/api/common/user/widget/menu/${param.menuNum}`);
